import { TTypeOfCodec } from "../../shared/src/codecs/codec";
import { boolean } from "../../shared/src/codecs/types/boolean";
import { date } from "../../shared/src/codecs/types/date";
import { dateTime } from "../../shared/src/codecs/types/dateTime";
import { literal } from "../../shared/src/codecs/types/literal";
import { nullCodec } from "../../shared/src/codecs/types/nullCodec";
import { required } from "../../shared/src/codecs/types/required";
import { string } from "../../shared/src/codecs/types/string";
import { union } from "../../shared/src/codecs/types/union";
import { uuid } from "../../shared/src/codecs/types/uuid";

const ns = () => union([nullCodec(), string()]);
const nd = () => union([nullCodec(), date()]);

export const CasesEpcStatus = union([
    literal("pending"),
    literal("valid"),
    literal("expired"),
    literal("none_found"),
    literal("not_required"),
]);
export type TCasesEpcStatus = TTypeOfCodec<typeof CasesEpcStatus>;

export const CasesEpcRating = union([
    nullCodec(),
    literal("A"), literal("B"), literal("C"), literal("D"),
    literal("E"), literal("F"), literal("G"), literal("exempt"),
]);
export type TCasesEpcRating = TTypeOfCodec<typeof CasesEpcRating>;

export const CasesEpcWhoArranges = union([
    literal("unknown"),
    literal("us"),
    literal("client"),
]);
export type TCasesEpcWhoArranges = TTypeOfCodec<typeof CasesEpcWhoArranges>;

export const CasesEpc1 = required({
    case_id: uuid(),
    status: CasesEpcStatus,
    certificate_number: ns(),
    rating: CasesEpcRating,
    registration_date: nd(),
    expiry_date: nd(),
    source_url: ns(),
    doc_id: union([nullCodec(), uuid()]),
    matched_uprn: ns(),
    who_arranges_new_epc: CasesEpcWhoArranges,
    new_epc_sorted: boolean(),
    last_lookup_at: union([nullCodec(), dateTime()]),
});
export type TCasesEpc1Codec = typeof CasesEpc1;
export type TCasesEpc1 = TTypeOfCodec<typeof CasesEpc1>;
